<app-benefits>
    <mat-card>
        <mat-card-title class="header">
            <h4 appLocalizationPopupDirective localizationCode="Benefits-Plan">{{ 'Benefits-Plan' | translate: {Default: "Plan"} }}</h4>

            <div class="buttons-container" *ngIf="form">
                <button mat-raised-button routerLink="{{routes.BENEFITS}}{{routes.PLANS}}">Return To Plans List</button> 
                <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid">Save</button> 
            </div>
        </mat-card-title>
        <mat-card-content>
            
            <div class="plan-details-form">
                <ng-container *ngIf="form === undefined">
                    <ngx-skeleton-loader
                        count="5"
                        [theme]="{ 
                            'height.px': 50
                        }"
                    ></ngx-skeleton-loader>
                </ng-container>

                <form class="form" *ngIf="form" [formGroup]="form">
                
                    <app-localization-text-form-field
                        [formElement]="{ formControl: 'name', localizationValueParam: 'text', text: ('BenefitPlanName' | translate: {Default: 'Name'}), disabled: 'false' }"
                        [parentGroup]="form"
                        [cultures]="cultures"
                        (emitAddtoFormArray)="addNewLocalization()"
                        (emitDeleteFromFormArray)="deleteLocalization($event.index)"
                    ></app-localization-text-form-field>
                
                    <app-localization-text-area-form-field
                        [formElement]="{ formControl: 'description', localizationValueParam: 'text', text: ('BenefitPlanDescription' | translate: {Default: 'Description'}), disabled: 'false' }"
                        [parentGroup]="form"
                        [cultures]="cultures"
                        (emitAddtoFormArray)="addNewDescriptionLocalization()"
                        (emitDeleteFromFormArray)="deleteDescriptionLocalization($event.index)"
                    ></app-localization-text-area-form-field>
                
                    <div class="form-section">
                        <div class="form-section-title">
                            <h6></h6>
                        </div>
                        <div class="form-section-contents">
                            <div class="section-row">
                                <mat-form-field appearance="fill">
                                    <mat-label>
                                        Contract Number
                                    </mat-label>
                                    
                                    <input 
                                        matInput
                                        type="text"
                                        formControlName="contractNumber">
                                </mat-form-field>

                                <mat-form-field appearance="fill">
                                    <mat-label>
                                        Plan Type
                                    </mat-label>
                            
                                    <mat-select disableOptionCentering formControlName="planType">
                                        <ng-container *ngIf="planTypeOptions | async as planTypeOptions">
                                            <mat-option></mat-option>
                                            <mat-option 
                                                *ngFor="let option of planTypeOptions" 
                                                [value]="option.id">
                                                    {{option.name}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                
                                <mat-form-field appearance="fill">
                                    <mat-label>
                                        Rate Type
                                    </mat-label>
                            
                                    <mat-select disableOptionCentering formControlName="rateType">
                                        <ng-container *ngIf="rateTypeOptions | async as rateTypeOptions">
                                            <mat-option></mat-option>
                                            <mat-option 
                                                *ngFor="let option of rateTypeOptions" 
                                                [value]="option.id">
                                                    {{option.name}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                
                                <mat-form-field appearance="fill">
                                    <mat-label>
                                        Plan Provider
                                    </mat-label>
                            
                                    <mat-select disableOptionCentering formControlName="planProvider">
                                        <ng-container *ngIf="planProviderOptions | async as planProviderOptions">
                                            <mat-option></mat-option>
                                            <mat-option 
                                                *ngFor="let option of planProviderOptions.data" 
                                                [value]="option.id">
                                                    {{option.text}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                
                    <div class="form-section">
                        <div class="form-section-title">
                            <h6></h6>
                        </div>
                        <div class="form-section-contents">
                            <div class="section-row">
                                
                                <mat-form-field  appearance="fill">
                                    <mat-label>
                                        Start Date
                                    </mat-label>
                                
                                    <input matInput [matDatepicker]="startDatepicker" formControlName="startDate">
                                    <span fxLayout="row" matSuffix>
                                        <mat-datepicker-toggle  [for]="startDatepicker"></mat-datepicker-toggle>
                                    </span>
                                    <mat-datepicker #startDatepicker></mat-datepicker> 
                                    <mat-hint></mat-hint>
                                </mat-form-field>
                
                                <mat-form-field  appearance="fill">
                                    <mat-label>
                                        End Date
                                    </mat-label>
                                
                                    <input matInput [matDatepicker]="endDatepicker" formControlName="endDate">
                                    <span fxLayout="row" matSuffix>
                                        <mat-datepicker-toggle  [for]="endDatepicker"></mat-datepicker-toggle>
                                    </span>
                                    <mat-datepicker #endDatepicker></mat-datepicker> 
                                    <mat-hint></mat-hint>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
            <div class="right">
                <app-benefits-plan-coverage-list [planId]="planId"></app-benefits-plan-coverage-list>

                <app-benefits-plan-documents [planId]="planId"></app-benefits-plan-documents>
            </div>
        </mat-card-content>
    </mat-card>

</app-benefits>
